import { Message as ApiMessage } from '@infuse/api/e-connector/message';
import { Message, MessageType } from './model';
import { enumFromStringValue } from '@infuse/utils';

export const mapToDomain = (apiMessage: ApiMessage): Message => {
  return {
    ...apiMessage,
    messageType: enumFromStringValue(MessageType, apiMessage.messageType)
  };
};
